import _ from 'lodash';
import { metricNames } from '@linearb/linjs-common';
import AppRouter from 'common/AppRouter';
import { getColor } from 'common/constants/_colors';
import { METRICS_METADATA } from 'views/root/views/home/views/performance/views/CustomReport/consts';

const MET_GOAL_PERCENT = 95;

const ALMOST_MET_GOAL_PERCENT = 80;

export const GOALS_METRICS = [
  metricNames.PR_MERGED,
  metricNames.MERGED_LARGE_PRS,
  metricNames.MERGED_LONG_LIVING_PRS,
  metricNames.MERGED_REVIEW_REQUEST_HANGING,
  metricNames.MERGED_WITHOUT_REVIEW,
  metricNames.MERGED_WORK_AT_RISK_PRS,
  metricNames.MERGED_WITH_BASIC_REVIEW_PRS,
  metricNames.MERGED_LONG_REVIEW_PRS
];

export const GOALS_TYPES = {
  MET_GOAL: {
    colorName: 'malachite',
    order: 5
  },
  ALMOST_MET_GOAL_PERCENT: {
    colorName: 'pastelGreen',
    order: 4
  },
  DID_NOT_MEET_GOAL: {
    colorName: 'orangePeel',
    order: 3
  },
  NO_PRS_MERGED: {
    colorName: 'botticelli',
    textColorName: 'shark',
    order: 2
  },
  UNSET: {
    colorName: 'botticelli',
    order: 1
  }
};

const getIsMetGoalsByPercent = (percent, prsMergedSum) => {
  if (prsMergedSum === 0) {
    return GOALS_TYPES.NO_PRS_MERGED;
  }

  if (percent >= MET_GOAL_PERCENT) {
    return GOALS_TYPES.MET_GOAL;
  }

  if (percent >= ALMOST_MET_GOAL_PERCENT) {
    return GOALS_TYPES.ALMOST_MET_GOAL_PERCENT;
  } else {
    return GOALS_TYPES.DID_NOT_MEET_GOAL;
  }
};

export const getGoalsData = ({
  teamDashboardWidgetId,
  goals,
  history,
  getSettingOrDefinitionValue,
  selectedTeamId,
  isInTeamDashboard
}) => {
  const {
    settingTitle,
    settingName,
    setGoalText,
    goalsValues = _.noop,
    didNotMeetTooltipDescription = _.noop
  } = METRICS_METADATA[teamDashboardWidgetId];
  const goalPercentValues = goalsValues(goals) || {};
  const { percent, prsMergedSum, didNotMeetSum } = goalPercentValues;

  const settingValue =
    getSettingOrDefinitionValue({
      name: settingName,
      definitionLevel: 'team',
      teamId: selectedTeamId
    }) || {};

  const { violation_enabled = false, warning_enabled = false } = settingValue;
  const isGoalSetUp = isInTeamDashboard || violation_enabled || warning_enabled;

  const didNotMeetGoalTooltipDescription =
    didNotMeetTooltipDescription(settingValue);

  const { colorName, textColorName, order } = getIsMetGoalsByPercent(
    percent,
    prsMergedSum
  );

  const defaultPieData = {
    id: teamDashboardWidgetId,
    name: settingTitle,
    value: 1
  };

  return isGoalSetUp
    ? {
        ...defaultPieData,
        order,
        percent,
        prsMergedSum,
        didNotMeetSum,
        didNotMeetGoalTooltipDescription,
        color: getColor(colorName),
        colorName,
        textColorName
      }
    : {
        ...defaultPieData,
        order: GOALS_TYPES.UNSET.order,
        colorName: GOALS_TYPES.UNSET.colorName,
        color: getColor(GOALS_TYPES.UNSET.colorName),
        textColorName,
        setGoalText,
        setGoalLink: () => linkToGoalsSettings(history, teamDashboardWidgetId)
      };
};

export const getGoalsPieData = ({
  history,
  getSettingOrDefinitionValue,
  team,
  goals = [],
  teamDashboardWidgets
}) => {
  if (!goals.length) {
    return { goalsPieData: [] };
  }
  const selectedTeamId = team?.id;

  const allTeamDashboardWidgets = Object.entries(METRICS_METADATA)
    .filter(([key, value]) => value.isTeamGoals)
    .map(item => parseInt(item[0]));

  const goalsData = allTeamDashboardWidgets.map(teamDashboardWidgetId => {
    const isInTeamDashboard = teamDashboardWidgets.includes(
      teamDashboardWidgetId
    );

    return getGoalsData({
      teamDashboardWidgetId,
      goals,
      history,
      getSettingOrDefinitionValue,
      selectedTeamId,
      isInTeamDashboard
    });
  });

  const dataOrdered = _.orderBy(goalsData, 'order');
  const numOfUnsetGoals = dataOrdered.filter(({ order }) => order === 1).length;

  return {
    goalsPieData: dataOrdered,
    isAllGoalsUnset: allTeamDashboardWidgets.length === numOfUnsetGoals
  };
};

export const linkToGoalsSettings = (history, teamDashboardWidgetId) => {
  history.push({
    pathname: `${AppRouter.SETTINGS.path}/notifications`,
    state: teamDashboardWidgetId && { highlightId: teamDashboardWidgetId }
  });
};

export const emptyData = [...Array(7).keys()].map(() => {
  return {
    id: 27,
    name: '',
    value: 1,
    order: 3,
    percent: 100,
    color: '#D8DEEA'
  };
});
